const Images = [
  {
    key: 'computer',
    text: 'computer',
    value: 'https://img.icons8.com/ultraviolet/40/000000/computer.png',
    image: 'https://img.icons8.com/ultraviolet/40/000000/computer.png',
  },
  {
    key: 'home',
    text: 'house',
    value: 'https://img.icons8.com/ultraviolet/40/4a90e2/home--v1.png',
    image: 'https://img.icons8.com/ultraviolet/40/4a90e2/home--v1.png',
  },
  {
    key: 'short',
    text: 'short hair',
    value: 'https://img.icons8.com/ultraviolet/40/4a90e2/user-male.png',
    image: 'https://img.icons8.com/ultraviolet/40/4a90e2/user-male.png',
  },
  {
    key: 'woman',
    text: 'long hair',
    value: 'https://img.icons8.com/ultraviolet/40/4a90e2/user-female.png',
    image: 'https://img.icons8.com/ultraviolet/40/4a90e2/user-female.png',
  },
  {
    key: 'sun',
    text: 'sun',
    value: 'https://img.icons8.com/ultraviolet/40/4a90e2/sun--v2.png',
    image: 'https://img.icons8.com/ultraviolet/40/4a90e2/sun--v2.png',
  },
  {
    key: 'bag',
    text: 'work',
    value: 'https://img.icons8.com/ultraviolet/40/4a90e2/toolbox.png',
    image: 'https://img.icons8.com/ultraviolet/40/4a90e2/toolbox.png',
  },
  {
    key: 'twiiter',
    text: 'social media',
    value: 'https://img.icons8.com/ultraviolet/40/4a90e2/twitter.png',
    image: 'https://img.icons8.com/ultraviolet/40/4a90e2/twitter.png',
  },
  {
    key: 'drib',
    text: 'drib',
    value: 'https://img.icons8.com/ultraviolet/40/4a90e2/dribbble.png',
    image: 'https://img.icons8.com/ultraviolet/40/4a90e2/dribbble.png',
  },
  {
    key: 'music',
    text: 'music',
    value: 'https://img.icons8.com/ultraviolet/40/4a90e2/music.png',
    image: { avatar: true, src: 'https://img.icons8.com/ultraviolet/40/4a90e2/music.png' },
  },
];
export default Images;
